module.exports = __webpack_public_path__ + "static/media/makeover_brand_banner_2.6486b2bb.jpg";